import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactCTA from './components/ContactCTA';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
      name: 'Vixtra',
      url: import.meta.env.VITE_SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://storage.readdy-site.link/project_files/766ecf38-5aae-4b99-ad7c-3b9a28df6201/4b39bf62-c5e4-4bc8-a85b-8ffbe72ab4ca_VixtraLogo.png?v=a7e79daeb5093b144c08c9d5f97ff157',
        width: 200,
        height: 60,
      },
      description:
        'Vixtra is a company focused on the development, manufacture and distribution of unique innovative products and services for applications where there is an evident unmet need.',
      telephone: '+16138000431',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+16138000431',
        contactType: 'customer service',
        availableLanguage: ['English', 'French'],
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'Vixtra',
      publisher: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      potentialAction: {
        '@type': 'SearchAction',
        target: `${import.meta.env.VITE_SITE_URL}/?s={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/`,
      url: `${import.meta.env.VITE_SITE_URL}/`,
      name: 'Vixtra | Innovative Products & Services',
      description:
        'Vixtra is a company focused on developing, manufacturing and distributing unique innovative products and services that address unmet needs and improve quality of care.',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      inLanguage: 'en',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: `${import.meta.env.VITE_SITE_URL}/`,
          },
        ],
      },
    },
  ],
};

const HomePage = () => {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(HOME_SCHEMA);
    document.title = 'Vixtra | Innovative Products & Services';
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
